"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferFullnessExit_1 = require("./Constants/BufferFullnessExit");
var State_1 = require("./Constants/State");
function createStatePanicMode() {
    return {
        label: State_1.default.PANICMODE,
        entry: function (params) {
            var callbacks = params.callbacks, abrState = params.abrState;
            callbacks.timeoutAllActiveHttpRequests();
            callbacks.setTimeoutFirstByte(1000);
            callbacks.setTimeoutLoad(2000);
            // we are desperate to load a video fragment as quickly as possible
            // set the lowest quality variant available
            callbacks.setCurrentVariantIndex(abrState.variants.length - 1);
        },
        update: function (params) {
            var metrics = params.metrics, callbacks = params.callbacks;
            var bufferDepth = metrics.bufferedDuration.min;
            if (bufferDepth >= BufferFullnessExit_1.default.PANICMODE_TO_REBUFFER) {
                callbacks.setState(State_1.default.REBUFFER);
            }
        }
    };
}
exports.default = createStatePanicMode;
//# sourceMappingURL=createStatePanicMode.js.map